// extracted by mini-css-extract-plugin
export default {"orders-list":"OrdersList_orders-list__lLZZs"};